import { mount } from "../shared/bootstrap.js";
import { App } from "./App.js";

mount(<App />, { serviceWorker: true });
